import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import type { components } from "../../../types/api.types";
import urls from "../../../urls";

type SiteSetupProcess = components["schemas"]["SiteSetupProcess"];

interface SiteSetupProcessesReturnValue {
  siteSetupProcesses: Array<SiteSetupProcess>;
  isLoading: boolean;
  error: unknown;
}

function useSiteSetupProcesses(
  variantId: number | undefined
): SiteSetupProcessesReturnValue {
  const { isLoading, error, data } = useQuery({
    queryKey: ["project-site-setup-processes-sites", { variantId }],
    queryFn: variantId ? () => fetchSetupProcesses(variantId) : skipToken,
    refetchInterval: false,
    refetchOnWindowFocus: false
  });

  return {
    isLoading,
    error,
    siteSetupProcesses: data || []
  };
}

export async function fetchSetupProcesses(variantId: number) {
  const response = await apiWithoutCamelization.get<Array<SiteSetupProcess>>(
    urls.apiWithoutCamelization.siteSetupAssistant.siteSetupProcesses(variantId)
  );
  return response.data;
}

export { SiteSetupProcess, useSiteSetupProcesses };
